export var playSound = function playSound(audioSource, audioRef, play, setPlay) {
    if (!audioSource) {
        return;
    }
    // Stop and reset any currently playing audio
    if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
    }
    if (play) {
        // Create new audio and store it in the ref
        var sound = new Audio(audioSource);
        sound.play()["catch"](function (error) {
            if (error.name !== 'AbortError') {
                console.error('Audio playback error:', error);
            }
        });
        // Optional: Reset play state when sound ends
        sound.onended = function () {
            if (setPlay)
                setPlay(false);
        };
    }
    // Cleanup function for useEffect (runs on unmount or before re-running effect)
    return function () {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current = null;
        }
        if (setPlay)
            setPlay(false);
    };
};
